/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum Gender {
    Male = 0,
    Female = 1,
    Other = 2,
}
